import { createRouter, createWebHashHistory } from "vue-router";
import UsedOnboardingIndex from "@/pages/OnboardingIndex.vue";
import UsedOnboardingTermConditionIndex from "@/components/partials/onboarding/termandcondition.vue";
import UsedOnboardingPrivacyPolicy from "@/components/partials/onboarding/privacypolicy.vue";
import UsedMaintenanceNotFound from "@/pages/maintenance/NotFoundIndex.vue";
import UsedLoginIndex from "@/pages/LoginIndex.vue";
import UsedRegisterIndex from "@/pages/RegisterIndex.vue";
import UsedResetControlNumberIndex from "@/pages/ResetControlNumber.vue";
import UsedAccountPortalIndex from "@/pages/portal/LandingIndex.vue";
import UsedQueingIndex from "@/pages/portal/QueuingIndex.vue";
import UsedTransactionIndex from "@/pages/portal/TransactionIndex.vue";
import UsedTransactionDetailIndex from "@/pages/portal/TransactionDetailIndex.vue";
import UsedAccountProfileIndex from "@/pages/portal/AccountIndex.vue";


import UsedDummyFileLaboratoryTestIndex from "@/pages/dummy/LaboratoryTestIndex.vue";
import axios from "@/utils/axios";

const routes = [
  {
    path: "/",
    name: "Onboarding",
    component: UsedOnboardingIndex,
    meta: {
      title: "Welcome",
      layout: "General",
      requiresAuth: false,
    },
  },
  {
    path: "/termsandconditions",
    name: "TermCondition",
    component: UsedOnboardingTermConditionIndex,
    meta: {
      title: "Terms and Conditions",
      layout: "General",
      requiresAuth: false,
    },
  },
   {
    path: "/privacypolicy",
    name: "PrivacyPolicy",
    component: UsedOnboardingPrivacyPolicy,
    meta: {
      title: "Privacy Policy",
      layout: "General",
      requiresAuth: false,
    },
  },
   {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: UsedMaintenanceNotFound,
    meta: {
      title: "Not Found",
      layout: "General",
      requiresAuth: false,
    },
  },
  {
    path: "/portal/login",
    name: "Login",
    component: UsedLoginIndex,
    meta: {
      title: "Welcome to Login",
      layout: "General",
      requiresAuth: false,
    },
  },
  {
    path: "/portal/registration",
    name: "Registration",
    component: UsedRegisterIndex,
    meta: {
      title: "Registration",
      layout: "General",
      requiresAuth: false,
    },
  },
  {
    path: "/portal",
    name: "MyAccount",
    component: UsedAccountPortalIndex,
    meta: {
      title: "Portal",
      layout: "Account",
      requiresAuth: true,
    },
  },
   {
    path: "/portal/account/profile",
    name: "AccountProfile",
    component: UsedAccountProfileIndex,
    meta: {
      title: "Profile",
      layout: "Account",
      requiresAuth: true,
    },
  },
  {
    path: "/portal/transaction",
    name: "Transaction",
    component: UsedTransactionIndex,
    meta: {
      title: "Portal",
      layout: "Account",
      requiresAuth: true,
    },
  },
  {
    path: "/portal/transaction/:id(.*)",
    name: "Queuing",
    component: UsedQueingIndex,
    meta: {
      title: "Portal",
      layout: "Account",
      requiresAuth: true,
    },
  },
  {
    path: "/portal/transaction/details/:id(.*)",
    name: "TransactionDetails",
    component: UsedTransactionDetailIndex,
    meta: {
      title: "Portal",
      layout: "Account",
      requiresAuth: true,
    },
  },
  {
    path: "/portal/reset-account",
    name: "ResetAccount",
    component: UsedResetControlNumberIndex,
    meta: {
      title: "Reset Control Number",
      layout: "General",
      requiresAuth: false,
    },
  },
  {
    path: "/portal/mock/data-entry/laboratory/:id(.*)",
    name: "LabTest",
    component: UsedDummyFileLaboratoryTestIndex,
    meta: {
      title: "Laboratory Test",
      layout: "General",
      requiresAuth: false,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});


router.beforeEach(async (to, from, next) => {
   document.title = `IMF Telemedicine`;
  let isAuthenticate;
  try {
    let { data } = await axios.get(`api/authorization`);
    isAuthenticate = data.authorized;
  } catch (error) {
    console.log(error);
  }
  
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticate) {
      next({ path: "/portal/login" });
    } else {
      next();
    }
  } else {
    if (to.name === "Login" && isAuthenticate) {
      next({ path: "/portal/" });
    } else {
      next();
    }
  }
});

export default router;
